import React from 'react'
import MagazaButonlari from './magaza-butonlari'

// Uygulamanın güncel ekranları (HatimTakip/store-assets/raw'dan küçültüldü); ortadaki en önde
const EKRANLAR = [
    { src: 'quran_menu', alt: "Kur'an-ı Kerim menüsü" },
    { src: 'mushaf', alt: 'Mushaf okuma ekranı' },
    { src: 'home', alt: 'Uygulama ana sayfası' },
    { src: 'risale', alt: 'Risale-i Nur Külliyatı' },
    { src: 'dua', alt: 'Dua ve zikirler' }
];

export default function DownloadV2() {
    return (
        <section className="ht-sec" id="download">
            <div className="ht-wrap">
                <div className="ht-card ht-dl-card">
                    <svg className="ht-rings" style={{ right: -160, top: -160 }} width="520" height="520" viewBox="0 0 220 220" fill="none" aria-hidden="true">
                        <circle cx="110" cy="110" r="108" stroke="#0B3A44" strokeOpacity="0.12" />
                        <circle cx="110" cy="110" r="80" stroke="#0B3A44" strokeOpacity="0.09" />
                        <circle cx="110" cy="110" r="52" stroke="#0B3A44" strokeOpacity="0.09" />
                    </svg>
                    <div className="ht-dl-text">
                        <h2 className="ht-h2">Hemen indirin ve hatim takibine başlayın</h2>
                        <p className="ht-lead-p">
                            HatimTakip uygulamasını şimdi indirerek bireysel veya grup halinde
                            Kur'an-ı Kerim ve Risale-i Nur okuma deneyiminizi kolaylaştırın.
                        </p>
                        <MagazaButonlari />
                    </div>
                    <div className="ht-dl-stage">
                        {EKRANLAR.map((e, i) => (
                            <figure key={e.src} className={`ht-phone ht-phone-${i === 2 ? 'c' : `${i < 2 ? 'l' : 'r'}${Math.abs(i - 2)}`}`}>
                                <img src={`/assets/images/ekran/${e.src}.jpg`} alt={e.alt} loading="lazy" width={560} height={1245} />
                            </figure>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
